import React from 'react'
import "../styles/components/ValorantTeam.css"

function ValorantTeam() {
    return (
        <section class="team team-valorant" id='team-valorant'>
            <div class="result-header result-header-valorant">
                <h2>GRANDSPIRIT TEAM</h2>
                <img src="./img/equipes/logo-valo-01-330x70.png" alt=""/>
                <a href="#" class="result-btn result-btn-valorant">Voir nos résultats</a>
            </div>

            <div class="card member-one">
                <img src="./img/equipes/portrait1.png" alt=""/>
                <p>Rayid</p>
            </div>


            <div class="card member-two">
                <img src="./img/equipes/portrait2.png" alt=""/>
                <p>Undefined</p>
            </div>


            <div class="card member-three">
                <img src="./img/equipes/portrait3.png" alt=""/>
                <p>Rezless</p>
            </div>


            <div class="card member-four">
                <img src="./img/equipes/portrait4.png" alt=""/>
                <p>Maestro</p>
            </div>



            <div class="card member-five">
                <img src="./img/equipes/portrait5.png" alt=""/>
                <p>Nemoo</p>
            </div>


            <div class="card member-six">
                <img src="./img/equipes/portrait1.png" alt=""/>
                <p>Mylent</p>
            </div>

            <div class="card member-seven">
                <img src="./img/equipes/portrait6.png" alt=""/>
                <p>Adriantje</p>
            </div>
        </section>
    )
}

export default ValorantTeam